export interface Classification {
  Code: number;
  Name: string;
  Description?: string;
  Subclasses?: Classification[];
  Parent?: Classification;
  Level?: number;
}

const Classifications: Classification[] = [
  {
    Code: 1000,
    Name: "Places",
    Description: "Points indicating the location of cities, towns, etc",
    Subclasses: [
      {
        Code: 1001,
        Name: "City",
        Description:
          "As defined by national/state/provincial government. Often over 100,000 people",
      },
      {
        Code: 1002,
        Name: "Town",
        Description:
          "As defined by national/state/provincial government. Generally smaller than a city, between 10,000 and 100,000 people",
      },
      {
        Code: 1003,
        Name: "Village",
        Description:
          "As defined by national/state/provincial government. Generally smaller than a town, below 10,000 people",
      },
      {
        Code: 1004,
        Name: "Hamlet",
        Description:
          "As defined by national/state/provincial government. Generally smaller than a village, just a few houses",
      },
      {
        Code: 1005,
        Name: "National Capital",
      },
      {
        Code: 1010,
        Name: "Suburb",
        Description: "Named area of town or city",
      },
      {
        Code: 1020,
        Name: "Island",
      },
      {
        Code: 1030,
        Name: "Farm",
        Description: "Named farm",
      },
      {
        Code: 1031,
        Name: "Dwelling",
        Description: "Isolated dwelling (1 or 2 houses, smaller than hamlet)",
      },
      {
        Code: 1040,
        Name: "Region",
        Description: "A region label (used in some areas only)",
      },
      {
        Code: 1041,
        Name: "Country",
        Description: "A county label (used in some areas only)",
      },
      {
        Code: 1050,
        Name: "Locality",
      },
    ],
  },
  {
    Code: 2000,
    Name: "Points Of Interest",
    Description: "Points indicating the location of points of interest",
    Subclasses: [
      {
        Code: 2001,
        Name: "Police",
        Description: "A police post or station",
      },
      {
        Code: 2002,
        Name: "Fire Station",
      },
      {
        Code: 2004,
        Name: "Post Box",
        Description: "A post box (for letters)",
      },
      {
        Code: 2005,
        Name: "Post Office",
      },
      {
        Code: 2006,
        Name: "Telephone",
        Description: "A public telephone booth",
      },
      {
        Code: 2007,
        Name: "Library",
      },
      {
        Code: 2008,
        Name: "Town Hall",
      },
      {
        Code: 2009,
        Name: "Courthouse",
      },
      {
        Code: 2010,
        Name: "Prison",
      },
      {
        Code: 2011,
        Name: "Embassy",
        Description: "An embassy or consulate",
      },
      {
        Code: 2012,
        Name: "Community Centre",
        Description:
          "A public facility which is mostly used by local associations for events and festivities",
      },
      {
        Code: 2013,
        Name: "Nursing Home",
        Description:
          "A home for disabled or elderly persons who need permanent care",
      },
      {
        Code: 2014,
        Name: "Arts Centre",
        Description:
          "A venue at which a variety of arts are performed or conducted, and may well be involved with the creation of those works, and run occasional courses.",
      },
      {
        Code: 2015,
        Name: "Graveyard",
      },
      {
        Code: 2016,
        Name: "Market Place",
        Description: "A place where markets are held",
      },
      {
        Code: 2030,
        Name: "Recycling",
        Description:
          "A place (usually a container) where you can drop waste for recycling",
        Subclasses: [
          {
            Code: 2031,
            Name: "Glass Recycling",
          },
          {
            Code: 2032,
            Name: "Paper Recycling",
          },
          {
            Code: 2033,
            Name: "Clothes Recycling",
          },
          {
            Code: 2034,
            Name: "Metal Recycling",
          },
        ],
      },
      {
        Code: 2080,
        Name: "Education",
        Subclasses: [
          {
            Code: 2081,
            Name: "University",
          },
          {
            Code: 2082,
            Name: "School",
          },
          {
            Code: 2083,
            Name: "Kindergarten (Nursery)",
          },
          {
            Code: 2084,
            Name: "College",
          },
        ],
      },
      {
        Code: 2099,
        Name: "Unspecified Public Building",
      },
      {
        Code: 2100,
        Name: "Health",
        Description:
          "Points indicating the location of health points of interest",
        Subclasses: [
          {
            Code: 2101,
            Name: "Pharmacy",
          },
          {
            Code: 2110,
            Name: "Hospital",
          },
          {
            Code: 2120,
            Name: "Doctors Practice",
          },
          {
            Code: 2121,
            Name: "Dentist Practice",
          },
          {
            Code: 2129,
            Name: "Veterinary Practice",
          },
        ],
      },
      {
        Code: 2200,
        Name: "Leisure",
        Description:
          "Points indicating the location of leisure points of interest",
        Subclasses: [
          {
            Code: 2201,
            Name: "Theatre",
          },
          {
            Code: 2202,
            Name: "Nightclub",
            Description: "A night club, or disco",
          },
          {
            Code: 2203,
            Name: "Cinema",
          },
          {
            Code: 2204,
            Name: "Park",
          },
          {
            Code: 2205,
            Name: "Playground",
            Description: "A playground for children",
          },
          {
            Code: 2206,
            Name: "Dog Park",
            Description:
              "An area where dogs are allowed to run free without a leash",
          },
          {
            Code: 2250,
            Name: "Sports",
            Subclasses: [
              {
                Code: 2251,
                Name: "Sports Centre",
                Description:
                  "A facility where a range of sports activities can be pursued",
              },
              {
                Code: 2252,
                Name: "Pitch",
                Description: "An area set aside for a specific sport",
              },
              {
                Code: 2253,
                Name: "Swimming Pool",
                Description: "A swimming pool or water park",
              },
              {
                Code: 2254,
                Name: "Tennis Court",
              },
              {
                Code: 2255,
                Name: "Golf Course",
              },
              {
                Code: 2256,
                Name: "Stadium",
                Description:
                  "A  stadium. The area of the stadium may contain one or several pitches",
              },
              {
                Code: 2257,
                Name: "Ice Rink",
              },
            ],
          },
        ],
      },
      {
        Code: 2300,
        Name: "Catering",
        Description:
          "Points indicating the location of catering points of interest",
        Subclasses: [
          {
            Code: 2301,
            Name: "Restaurant",
          },
          {
            Code: 2302,
            Name: "Fast Food",
          },
          {
            Code: 2303,
            Name: "Cafe",
          },
          {
            Code: 2304,
            Name: "Pub",
          },
          {
            Code: 2305,
            Name: "Bar",
            Description:
              "A bar. The difference between a pub and a bar is not clear but pubs tend to offer food while bars do not",
          },
          {
            Code: 2306,
            Name: "Food Court",
            Description: "A common seating area with various fast-food vendors",
          },
          {
            Code: 2307,
            Name: "Biergarten",
            Description: "An open-air area where food and drinks are served",
          },
        ],
      },
      {
        Code: 2400,
        Name: "Accommodation",
        Description:
          "Points indicating the location of accommodation points of interest",
        Subclasses: [
          {
            Code: 2401,
            Name: "Hotel",
            Description:
              "The difference between hotel, bed and breakfast, and guest houses is not a strict one and OSM tends to use whatever the facility calls itself.",
          },
          {
            Code: 2402,
            Name: "Motel",
          },
          {
            Code: 2403,
            Name: "Bed and Breakfast",
            Description:
              "The difference between hotel, bed and breakfast, and guest houses is not a strict one and OSM tends to use whatever the facility calls itself.",
          },
          {
            Code: 2404,
            Name: "Guesthouse",
            Description:
              "The difference between hotel, bed and breakfast, and guest houses is not a strict one and OSM tends to use whatever the facility calls itself.",
          },
          {
            Code: 2405,
            Name: "Hostel",
            Description:
              "A hostel (offering cheap accommodation, often bunk beds in dormitories)",
          },
          {
            Code: 2406,
            Name: "Chalet",
            Description: "A detached cottage, usually selfcatering",
          },
          {
            Code: 2420,
            Name: "Outdoor Accommodation",
            Description:
              "Points indicating the location of outdoor accommodation points of interest",
            Subclasses: [
              {
                Code: 2421,
                Name: "Shelter",
                Description:
                  "All sorts of small shelters to protect against bad weather conditions",
              },
              {
                Code: 2422,
                Name: "Camp Site",
                Description: "A camp site or camping ground",
              },
              {
                Code: 2423,
                Name: "Alpine Hut",
                Description:
                  "An alpine hut is a building typically situated in mountains providing shelter and often food and beverages to visitors",
              },
              {
                Code: 2424,
                Name: "Caravan Site",
                Description:
                  "A place where people with caravans or motorhomes can stay overnight or longer",
              },
            ],
          },
        ],
      },
      {
        Code: 2500,
        Name: "Shopping",
        Description:
          "Points indicating the location of shopping points of interest",
        Subclasses: [
          {
            Code: 2501,
            Name: "Supermarket",
          },
          {
            Code: 2502,
            Name: "Bakery",
          },
          {
            Code: 2503,
            Name: "Kiosk",
            Description:
              "A very small shop usually selling cigarettes, newspapers, sweets, snacks and beverages",
          },
          {
            Code: 2504,
            Name: "Mall",
          },
          {
            Code: 2505,
            Name: "Department Store",
          },
          {
            Code: 2510,
            Name: "General",
            Description:
              "A general store, offering a broad  range of products on a small area. Exists usually in rural and remote areas.",
          },
          {
            Code: 2511,
            Name: "Convenience",
            Description:
              "A convenience store is a small shop selling a subset of items you might find at a supermarket",
          },
          {
            Code: 2512,
            Name: "Clothes",
            Description: "A clothes or fashion store",
          },
          {
            Code: 2513,
            Name: "Florist",
          },
          {
            Code: 2514,
            Name: "Chemist",
            Description:
              " A shop selling articles of personal hygiene, cosmetics, and household cleaning products",
          },
          {
            Code: 2515,
            Name: "Bookshop",
          },
          {
            Code: 2516,
            Name: "Butcher",
          },
          {
            Code: 2517,
            Name: "Shoe Shop",
          },
          {
            Code: 2518,
            Name: "Beverages",
            Description:
              "A place where you can buy alcoholic and non-alcoholic beverages",
          },
          {
            Code: 2519,
            Name: "Optician",
          },
          {
            Code: 2520,
            Name: "Jeweller",
          },
          {
            Code: 2521,
            Name: "Gift Shop",
          },
          {
            Code: 2522,
            Name: "Sports Shop",
          },
          {
            Code: 2523,
            Name: "Stationery",
          },
          {
            Code: 2524,
            Name: "Outdoor Shop",
          },
          {
            Code: 2525,
            Name: "Mobile Phone Shop",
          },
          {
            Code: 2526,
            Name: "Toy Shop",
          },
          {
            Code: 2527,
            Name: "Newsagent",
          },
          {
            Code: 2528,
            Name: "Greengrocer",
          },
          {
            Code: 2529,
            Name: "Beauty Shop",
            Description:
              "A shop that provides personal beauty services like a nail salon or tanning salon",
          },
          {
            Code: 2530,
            Name: "Video Shop",
          },
          {
            Code: 2541,
            Name: "Car Dealership",
          },
          {
            Code: 2542,
            Name: "Bicycle Shop",
          },
          {
            Code: 2543,
            Name: "DIY Shop",
            Description:
              "A do-it-yourself shop where you can buy tools and building materials",
          },
          {
            Code: 2544,
            Name: "Furniture Shop",
          },
          {
            Code: 2546,
            Name: "Computer Shop",
          },
          {
            Code: 2547,
            Name: "Garden Centre",
          },
          {
            Code: 2561,
            Name: "Hairdresser",
          },
          {
            Code: 2562,
            Name: "Car Repair",
          },
          {
            Code: 2563,
            Name: "Car Rental",
          },
          {
            Code: 2564,
            Name: "Car Wash",
          },
          {
            Code: 2565,
            Name: "Car Sharing",
          },
          {
            Code: 2566,
            Name: "Bicycle Rental",
          },
          {
            Code: 2567,
            Name: "Travel Agent",
          },
          {
            Code: 2568,
            Name: "Laundry",
          },
          {
            Code: 2590,
            Name: "Vending Machine",
            Subclasses: [
              {
                Code: 2591,
                Name: "Cigarette",
              },
              {
                Code: 2592,
                Name: "Parking",
              },
            ],
          },
        ],
      },
      {
        Code: 2600,
        Name: "Money",
        Description:
          "Points indicating the location of money points of interest",
        Subclasses: [
          {
            Code: 2601,
            Name: "Bank",
          },
          {
            Code: 2602,
            Name: "ATM",
          },
        ],
      },
      {
        Code: 2700,
        Name: "Tourism",
        Description:
          "Points indicating the location of tourism points of interest",
        Subclasses: [
          {
            Code: 2701,
            Name: "Tourist Info",
            Description:
              "Something that provides information to tourists; may or many not be manned",
          },
          {
            Code: 2704,
            Name: "Tourist Map",
            Description: " A map displayed to inform tourists",
          },
          {
            Code: 2705,
            Name: "Tourist Board",
            Description: "A board with explanations aimed at tourists",
          },
          {
            Code: 2706,
            Name: "Tourist Guidepost",
          },
          {
            Code: 2721,
            Name: "Tourist Attraction",
          },
          {
            Code: 2722,
            Name: "Museum",
          },
          {
            Code: 2723,
            Name: "Monument",
          },
          {
            Code: 2724,
            Name: "Memorial",
          },
          {
            Code: 2725,
            Name: "Art",
          },
          {
            Code: 2731,
            Name: "Castle",
          },
          {
            Code: 2732,
            Name: "Ruins",
          },
          {
            Code: 2733,
            Name: "Archaeological",
            Description: "An excavation site",
          },
          {
            Code: 2734,
            Name: "Wayside Cross",
            Description: "A wayside cross, not necessarily old",
          },
          {
            Code: 2735,
            Name: "Wayside Shrine",
          },
          {
            Code: 2736,
            Name: "Historic Battlefield",
          },
          {
            Code: 2737,
            Name: "Fort",
          },
          {
            Code: 2741,
            Name: "Picnic Site",
          },
          {
            Code: 2742,
            Name: "Viewpoint",
          },
          {
            Code: 2743,
            Name: "Zoo",
          },
          {
            Code: 2744,
            Name: "Theme Park",
          },
        ],
      },
      {
        Code: 2900,
        Name: "Miscellaneous",
        Description:
          "Points indicating the location of miscellaneous points of interest",
        Subclasses: [
          {
            Code: 2901,
            Name: "Toilet",
          },
          {
            Code: 2902,
            Name: "Bench",
          },
          {
            Code: 2903,
            Name: "Drinking Water",
            Description: "A tap or other source of drinking water",
          },
          {
            Code: 2904,
            Name: "Fountain",
            Description:
              "A fountain for cultural, decorative, or recreational purposes",
          },
          {
            Code: 2905,
            Name: "Hunting Stand",
          },
          {
            Code: 2906,
            Name: "Waste Basket",
          },
          {
            Code: 2907,
            Name: "Surveillance Camera",
          },
          {
            Code: 2921,
            Name: "Emergency Phone",
          },
          {
            Code: 2922,
            Name: "Fire Hydrant",
          },
          {
            Code: 2923,
            Name: "Emergency Access",
            Description:
              "An emergency access point (signposted place in e.g. woods the location of which is known to emergency services)",
          },
          {
            Code: 2950,
            Name: "Tower",
            Subclasses: [
              {
                Code: 2951,
                Name: "Communications Tower",
              },
              {
                Code: 2952,
                Name: "Water Tower",
              },
              {
                Code: 2953,
                Name: "Observation Tower",
              },
              {
                Code: 2954,
                Name: "Windmill",
              },
              {
                Code: 2955,
                Name: "Lighthouse",
              },
            ],
          },
          {
            Code: 2961,
            Name: "Wastewater Treatment Plant",
          },
          {
            Code: 2962,
            Name: "Water Well",
          },
          {
            Code: 2963,
            Name: "Water Mill",
          },
          {
            Code: 2964,
            Name: "Water Works",
          },
        ],
      },
    ],
  },
  {
    Code: 3000,
    Name: "Places of Worship",
    Description: "Points indicating the location of places of worship",
    Subclasses: [
      {
        Code: 3100,
        Name: "Christian",
        Description:
          "A christian place of worship (usually a church) without one of the following denominations",
        Subclasses: [
          {
            Code: 3101,
            Name: "Anglican",
          },
          {
            Code: 3102,
            Name: "Catholic",
          },
          {
            Code: 3103,
            Name: "Evangelical",
          },
          {
            Code: 3104,
            Name: "Lutheran",
          },
          {
            Code: 3105,
            Name: "Methodist",
          },
          {
            Code: 3106,
            Name: "Orthodox",
          },
          {
            Code: 3107,
            Name: "Protestant",
          },
          {
            Code: 3108,
            Name: "Baptist",
          },
          {
            Code: 3109,
            Name: "Mormon",
          },
        ],
      },
      {
        Code: 3200,
        Description: "A jewish place of worship (usually a synagogue)",
        Name: "Jewish",
      },
      {
        Code: 3300,
        Name: "Muslim",
        Description:
          "A muslim place of worship, (usually a mosque) without one of the following denominations",
        Subclasses: [
          {
            Code: 3301,
            Name: "Sunni",
          },
          {
            Code: 3302,
            Name: "Shia",
          },
        ],
      },
      {
        Code: 3400,
        Name: "Buddhist",
      },
      {
        Code: 3500,
        Name: "Hindu",
      },
      {
        Code: 3600,
        Name: "Taoist",
      },
      {
        Code: 3700,
        Name: "Shintoist",
      },
      {
        Code: 3800,
        Name: "Sikh",
      },
    ],
  },
  {
    Code: 4100,
    Name: "Natural",
    Description: "Points indicating the location of natural features",
    Subclasses: [
      {
        Code: 4101,
        Name: "Spring",
        Description: "A spring, possibly source of a stream",
      },
      {
        Code: 4103,
        Name: "Glacier",
      },
      {
        Code: 4111,
        Name: "Peak",
        Description: "A mountain peak",
      },
      {
        Code: 4112,
        Name: "Cliff",
      },
      {
        Code: 4113,
        Name: "Volcano",
      },
      {
        Code: 4121,
        Name: "Tree",
      },
      {
        Code: 4131,
        Name: "Mine",
      },
      {
        Code: 4132,
        Name: "Cave Entrance",
      },
      {
        Code: 4141,
        Name: "Beach",
        Description:
          "Note that beaches are only rarely mapped as point features",
      },
    ],
  },
  {
    Code: 5200,
    Name: "Traffic",
    Description: "Points indicating the location of traffic features",
    Subclasses: [
      {
        Code: 5201,
        Name: "Traffic Signals",
      },
      {
        Code: 5202,
        Name: "Mini Roundabout",
        Description:
          "A small roundabout without physical strucutre, usually just painted onto the road surface",
      },
      {
        Code: 5203,
        Name: "Stop Sign",
      },
      {
        Code: 5204,
        Name: "Crossing",
        Description:
          "A place where the street is crossed by pedestrians or a railway",
      },
      {
        Code: 5205,
        Name: "Ford",
        Description: "A place where the road runs through a river or stream",
      },
      {
        Code: 5206,
        Name: "Motorway Junction",
        Description: "The place where a slipway enters or leaves a motorway",
      },
      {
        Code: 5207,
        Name: "Turning Circle",
        Description: "An area at the end of a street where vehicles can turn",
      },
      {
        Code: 5208,
        Name: "Speed Camera",
        Description: "A camera that photographs speeding vehicles",
      },
      {
        Code: 5209,
        Name: "Street Lamp",
        Description: "A lamp illuminating the road",
      },
      {
        Code: 5210,
        Name: "Barrier",
        Subclasses: [
          {
            Code: 5211,
            Name: "Gate",
          },
          {
            Code: 5212,
            Name: "Bollard",
            Description:
              "A bollard intended as a barrier against wide vehicles",
          },
          {
            Code: 5213,
            Name: "Lift Gate",
          },
          {
            Code: 5214,
            Name: "Stile",
            Description: "A stile that allows climbing over a wall or fence",
          },
          {
            Code: 5215,
            Name: "Cycle Barrier",
            Description: "A barrier that keeps out cyclists",
          },
          {
            Code: 5216,
            Name: "Fence",
          },
          {
            Code: 5217,
            Name: "Toll",
            Description: "A place where you have to pay toll to continue",
          },
          {
            Code: 5218,
            Name: "Block",
            Description: "A solid concrete block or rock impeding traffic",
          },
          {
            Code: 5219,
            Name: "Kissing Gate",
          },
          {
            Code: 5220,
            Name: "Cattle Grid",
          },
        ],
      },
      {
        Code: 5230,
        Name: "Traffic Calming",
        Subclasses: [
          {
            Code: 5231,
            Name: "Hump",
            Description: "A hump in the street surface",
          },
          {
            Code: 5232,
            Name: "Bump",
            Description: "A bump – shorter than a hump",
          },
          {
            Code: 5233,
            Name: "Table",
            Description: "A table – longer than a hump",
          },
          {
            Code: 5234,
            Name: "Chicane",
            Description:
              "Some kind of traffic calming hazard in the street that has to be navigated",
          },
          {
            Code: 5235,
            Name: "Cushion",
            Description:
              "A special kind of hump that allows cyclists and wide vehicles to pass without slowing down",
          },
        ],
      },
      {
        Code: 5250,
        Name: "Fuel",
        Description: "A fuel station",
        Subclasses: [
          {
            Code: 5251,
            Name: "Service",
            Description: "A service area, usually along motorways",
          },
        ],
      },
      {
        Code: 5260,
        Name: "Parking",
        Subclasses: [
          {
            Code: 5261,
            Name: "Site",
          },
          {
            Code: 5262,
            Name: "Multistorey",
          },
          {
            Code: 5263,
            Name: "Underground",
          },
        ],
      },
      {
        Code: 5270,
        Name: "Parking Bicycle",
      },
    ],
  },
  {
    Code: 5300,
    Name: "Water Traffic",
    Description: "Points indicating the location of water traffic features",
    Subclasses: [
      {
        Code: 5301,
        Name: "Slipway",
      },
      {
        Code: 5302,
        Name: "Marina",
      },
      {
        Code: 5303,
        Name: "Pier",
      },
      {
        Code: 5311,
        Name: "Dam",
      },
      {
        Code: 5321,
        Name: "Waterfall",
      },
      {
        Code: 5331,
        Name: "Lock Gate",
      },
      {
        Code: 5332,
        Name: "Weir",
      },
    ],
  },
  {
    Code: 5600,
    Name: "Transport",
    Description: "Points indicating the location of transport infrastructure",
    Subclasses: [
      {
        Code: 5601,
        Name: "Railway Station",
        Description: "A larger railway station of mainline rail services",
      },
      {
        Code: 5602,
        Name: "Railway Halt",
        Description: " A smaller, local railway station, or subway station",
      },
      {
        Code: 5603,
        Name: "Tram Stop",
      },
      {
        Code: 5621,
        Name: "Bus Stop",
      },
      {
        Code: 5622,
        Name: "Bus Station",
        Description: "A large bus station with multiple platforms",
      },
      {
        Code: 5641,
        Name: "Taxi Rank",
      },
      {
        Code: 5650,
        Name: "Air Transport",
        Subclasses: [
          {
            Code: 5651,
            Name: "Airport",
          },
          {
            Code: 5652,
            Name: "Airfield",
            Description: "A small airport or airfield",
          },
          {
            Code: 5655,
            Name: "Helipad",
          },
          {
            Code: 5656,
            Name: "Apron",
            Description: "Area where aircraft are parked",
          },
        ],
      },
      {
        Code: 5660,
        Name: "Water Transport",
        Subclasses: [
          {
            Code: 5661,
            Name: "Ferry Terminal",
          },
        ],
      },
      {
        Code: 5670,
        Name: "Other Transport",
      },

      {
        Code: 5671,
        Name: "Aerialway Station",
        Description: "A station where cable cars or lifts alight",
      },
    ],
  },
  {
    Code: 6400,
    Name: "Power",
    Description:
      "Points indicating the location of power generation and distribution infrastructure",
    Subclasses: [
      {
        Code: 6401,
        Name: "Pylon",
        Description: "A towers supporting power lines",
      },
      {
        Code: 6204,
        Name: "Pole",
        Description: "A pole supporting power lines",
      },
      {
        Code: 6410,
        Name: "Power Station",
        Subclasses: [
          {
            Code: 6411,
            Name: "Nuclear",
          },
          {
            Code: 6412,
            Name: "Solar",
          },
          {
            Code: 6413,
            Name: "Fossil",
          },
          {
            Code: 6414,
            Name: "Hydroelectric",
          },
          {
            Code: 6415,
            Name: "Wind",
          },
        ],
      },
      {
        Code: 6422,
        Name: "Substation",
        Description: "A power substations or relay station",
      },
      {
        Code: 6423,
        Name: "Transformer",
        Description: "A power transformer within a station or substation",
      },
    ],
  },
];

const setParentClassification = (
  classifications: Classification[],
  parent: Classification | undefined,
  level: number,
) => {
  classifications.forEach((classification) => {
    classification.Parent = parent;
    classification.Level = level;
    if (classification.Subclasses)
      setParentClassification(
        classification.Subclasses,
        classification,
        level + 1,
      );
  });
};
setParentClassification(Classifications, undefined, 0);

export default Classifications;
